import React from 'react';
import { PlusIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
import { copy } from '../../data/copy';
import { formatShortDay } from '../../utils/time';
import { Button } from '../ui/Button';
import { SyncTag } from '../SyncTag';
export function TimeLogSection({
  memberId
}: {
  memberId: string;
}) {
  const {
    entries,
    viewer
  } = useAppState();
  const {
    openManualEntry
  } = useUi();
  const own = memberId === viewer.id;
  const list = entries.filter(e => e.memberId === memberId).sort((a, b) => b.date.localeCompare(a.date));
  const total = list.reduce((s, e) => s + e.minutes, 0);
  return <section aria-labelledby={`timelog-${memberId}`} data-id="element-390" data-mp="3j5m8imszhrbl">
      <div className="flex items-center justify-between gap-3" data-id="element-391" data-mp="3j4udbd3atvlu">
        <div data-id="element-392" data-mp="jimkj7341bqc">
          <h2 id={`timelog-${memberId}`} className="font-display text-xl font-semibold" data-id="element-393" data-mp="jie5b8jilubz">
            Dnevnik časa
          </h2>
          <p className="text-xs text-muted" data-id="element-394" data-mp="eorw5qck88kx">Skupaj {total} min · vidita ga član in skrbniki.</p>
        </div>
        {own && <Button variant="secondary" size="sm" onClick={() => openManualEntry()} data-id="element-395" data-mp="3l6d6dkg7i73j">
            <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-396" data-mp="36hqhar0s20z4" /> Ročni vnos
          </Button>}
      </div>
      {list.length === 0 ? <p className="mt-3 rounded-2xl border-[1.5px] border-dashed border-line p-4 text-sm text-muted" data-id="element-397" data-mp="3bfs49n1bqkfv">{copy.emptyLog}</p> : <ul className="mt-3 divide-y divide-line rounded-3xl border-[1.5px] border-line bg-surface" data-id="element-398" data-mp="2xj55rftq3m7u">
          {list.map(e => <li key={e.id} className="flex items-start gap-3 px-4 py-3" data-id="element-399" data-mp="2nj4k3n8dsu0h">
              <span className="w-16 shrink-0 pt-0.5 text-xs font-bold capitalize text-muted" data-id="element-400" data-mp="2nl8tulsyon8o">{formatShortDay(e.date)}</span>
              <span className="min-w-0 flex-1" data-id="element-401" data-mp="lrrgr2m2au6j">
                <span className="block font-bold leading-snug" data-id="element-402" data-mp="ls18aumr99ec">{e.activity}</span>
                <span className="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-muted" data-id="element-403" data-mp="qpb3kqwtsfa3">
                  <span data-id="element-404" data-mp="pb0a56rtm9mf">{e.source === 'casovnik' ? 'Časovnik' : 'Ročni vnos'}</span>
                  <span data-id="element-405" data-mp="k9avlh5e3dtl">·</span>
                  <span data-id="element-406" data-mp="k918c1bqbkrl">{e.templateId ? 'povezana naloga' : 'prosta dejavnost – brez točk'}</span>
                  {e.sync === 'pending' && <SyncTag sync="pending" data-id="element-407" data-mp="b9nukwgkoa12" />}
                </span>
                {e.note && <span className="mt-0.5 block text-xs italic text-muted" data-id="element-408" data-mp="bbquc87j1hiz">{e.note}</span>}
              </span>
              <span className="shrink-0 font-extrabold tabular-nums" data-id="element-409" data-mp="181rflx8otfvj">{e.minutes} min</span>
            </li>)}
        </ul>}
    </section>;
}